import { useState } from "react";
import { Outlet } from "react-router-dom";
// material
import { styled, useTheme } from "@material-ui/core/styles";
// hooks
import useCollapseDrawer from "../../hooks/useCollapseDrawer";
//
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import GlobalNewSignatureDialog from "../../components/_dashboard/signatures/GlobalNewSignatureDialog";
import { WebinarPromoDialog } from "../../components/__haim/DashboardMain/WebinarPromoDialog";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 64;

// `overflow: clip` (with the hidden/auto fallback for pre-Safari-16) instead of
// hidden/auto — DELIBERATE, load-bearing for `position: sticky` inside pages:
// hidden/auto make these divs the nearest "scroll container" for every sticky
// descendant, but NEITHER of them ever actually scrolls (both stretch to
// content height; the WINDOW is the real scroller — verified in ContactsPage's
// scroll-to-top logic). A sticky element whose scrollport never scrolls simply
// never pins (this silently killed the contact page's pinned header + the
// overview reference rail). `clip` clips identically and keeps the block
// formatting context, but does NOT create a scroll container — so sticky
// elements pin against the window, which is the scroller that actually moves.
const RootStyle = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
  "@supports (overflow: clip)": { overflow: "clip" }
});

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  "@supports (overflow: clip)": { overflow: "clip" },
  // Explicit, load-bearing with `clip`: as a SCROLL container (overflow:auto)
  // this flex item implicitly got min-width 0; a clip box is NOT a scroll
  // container, so min-width:auto tracks the widest content — one wide table
  // (e.g. AdminHome's team table) then blew the whole layout out of the page.
  minWidth: 0,
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 12,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle
        sx={{
          transition: theme.transitions.create("margin", {
            duration: theme.transitions.duration.complex
          }),
          ...(collapseClick && {
            ml: "102px"
          })
        }}
      >
        <Outlet />
      </MainStyle>
      <GlobalNewSignatureDialog />
      <WebinarPromoDialog />
    </RootStyle>
  );
}
